import { zRequiredString } from "@goodfill/domain-properties-zod-validators";

export const zPassword = zRequiredString()
  .min(8, "at least 8 characters required")
  .regex(new RegExp("[a-z]"), { message: "at least one lowercase character required" })
  .regex(new RegExp("[0-9]"), { message: "at least one number required" })
  .regex(new RegExp("[A-Z]"), { message: "at least one uppercase character required" })
  .regex(new RegExp(/[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\\,\>\<\'\:\;\|\_\~\`\=\+\-]/), {
    message: "at least one especial character required",
  });
